
import { defineComponent } from 'vue'

export default defineComponent(
{
    name: 'Footer',
    setup()
    {
        // Set consts:
        const menuItems =
        [
            {
                name: 'Cookies',
                text: 'Cookies'
            }
        ]

        // Return data:
        return {
            menuItems
        }
    }
})
